import { useQuery } from '@tanstack/react-query'

import { fetchRecommendations } from 'api/fetchers/marketing-capabilities/recommendations/fetchRecommendations'
import { useExploreLearnings } from 'store/ExploreLearnings'

export const useRecommendations = () => {
  const data = {}
  const search = useExploreLearnings(state => state.searchText)
  if (search.length > 2) {
    Object.assign(data, { searchTerm: search })
  }
  return useQuery({
    queryKey: ['recommendations', data],
    queryFn: ({ signal }: any) => fetchRecommendations(data)(signal),
    select: (data: any) => data.data,
  })
}
